// Agency (Team Booking) schemas — PRD §8 (managed logins), §10, §19.1.
// The Authority provisions employees directly: no email, no self-signup. The per-agency
// handle reuses the `username` primitive; the Authority may set a temp password or let the
// server generate one.
import { z } from 'zod';
import { username, slug, timezone, email } from './common.js';

// Create the agency container for the current owner (PRD §10 A).
export const createAgencySchema = z.object({
  name: z.string().trim().min(1).max(120),
  slug,
  brand_name: z.string().trim().max(120).optional(),
});

export const updateAgencySchema = z
  .object({
    name: z.string().trim().min(1).max(120),
    brand_name: z.string().trim().max(120).nullable(),
  })
  .partial();

// Authority creates an employee login (PRD §8.1). Email is the sign-in identity (the agent
// signs in at the normal /login). password omitted → server generates one and returns it once
// so the Authority can hand it over. username is the per-agency display handle.
export const createEmployeeSchema = z.object({
  display_name: z.string().trim().min(1).max(120),
  username,
  email,
  password: z.string().min(8).max(200).optional(),
  timezone: timezone.optional(),
});

// Authority edits roster metadata (PRD §8.3 Rename/edit). May also change the sign-in email.
// Never sets the password here (that's reset-password). All fields optional.
export const updateEmployeeSchema = z
  .object({
    display_name: z.string().trim().min(1).max(120),
    priority: z.number().int().min(-100).max(100),
    email,
  })
  .partial();

// Authority resets an employee password (PRD §8.3). Employee resets again on next sign-in.
export const resetEmployeePasswordSchema = z.object({
  password: z.string().min(8).max(200),
});

// Employee sets their own new password after first sign-in (PRD §8.2).
export const employeeSetPasswordSchema = z.object({
  password: z.string().min(8).max(200),
});
